import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';

import AddToArtlistIcon from '@/assets/all-icons/add-to-artlist-icon';
import useTranslations from '@/i18n/useTranslations';

import './styles/ProfileAddButton.css';

export default function ProfileAddButton({
  to,
  onClick = null,
  hidden = false,
  label = null,
  iconOnly = false,
  alignRight = false,
  ariaLabel = null
}) {
  const t = useTranslations('common.shared.profile_add_button');
  const navigate = useNavigate();
  const resolvedLabel = label || t('default_label');
  const resolvedAriaLabel = ariaLabel || resolvedLabel;

  const handleClick = onClick ?? (() => {
    if (!to) return;
    navigate(to, { state: { from: true } });
  });

  // Si "hidden" es true, no renderiza el botón
  if (hidden) return null;

  return createPortal(
    <div className={`profile-add-button__wrapper ${alignRight ? 'profile-add-button__wrapper--right' : ''}`}>
      <button 
        type="button"
        className={`profile-add-button__container ${iconOnly ? 'profile-add-button__container--icon-only' : ''}`}
        aria-label={resolvedAriaLabel}
        onClick={handleClick}
      >
        {iconOnly ? (
          <AddToArtlistIcon className="profile-add-button__icon" />
        ) : (
          <span className="profile-add-button__label">{resolvedLabel}</span>
        )}
      </button>
    </div>,
    document.getElementById("portal-generic-popup")
  );
}
